
export const PROMOTION_LIST_ACTION = "PROMOTION_LIST_ACTION";
export const PROMOTION_LIST_SUCCESS = "PROMOTION_LIST_SUCCESS";
export const PROMOTION_LIST_FAIL = "PROMOTION_LIST_FAIL";

export const PROMOTION_CHANGE_STATUS_CODE_ACTION = "PROMOTION_CHANGE_STATUS_CODE_ACTION";
export const PROMOTION_CHANGE_STATUS_CODE_SUCCESS = "PROMOTION_CHANGE_STATUS_CODE_SUCCESS";
export const PROMOTION_CHANGE_STATUS_CODE_FAIL = "PROMOTION_CHANGE_STATUS_CODE_FAIL";

export const PROMOTION_CAMPAIGN_LIST_ACTION = "PROMOTION_CAMPAIGN_LIST_ACTION"
export const PROMOTION_CAMPAIGN_LIST_SUCCESS = "PROMOTION_CAMPAIGN_LIST_SUCCESS"
export const PROMOTION_CAMPAIGN_LIST_FAIL = "PROMOTION_CAMPAIGN_LIST_FAIL"

export const PROMOTION_CAMPAIGN_LIST_FILTER_ACTION = "PROMOTION_CAMPAIGN_LIST_FILTER_ACTION"
export const PROMOTION_CAMPAIGN_LIST_FILTER_SUCCESS = "PROMOTION_CAMPAIGN_LIST_FILTER_SUCCESS"
export const PROMOTION_CAMPAIGN_LIST_FILTER_FAIL = "PROMOTION_CAMPAIGN_LIST_FILTER_FAIL"

export const BUNDLE_LIST_ACTION = "BUNDLE_LIST_ACTION"
export const BUNDLE_LIST_SUCCESS = "BUNDLE_LIST_SUCCESS"
export const BUNDLE_LIST_FAIL = "BUNDLE_LIST_FAIL"

export const PROMOTION_EXPORT_FILE_ACTION = "PROMOTION_EXPORT_FILE_ACTION"
export const PROMOTION_EXPORT_FILE_SUCCESS = "PROMOTION_EXPORT_FILE_SUCCESS"
export const PROMOTION_EXPORT_FILE_FAIL = "PROMOTION_EXPORT_FILE_FAIL"

export const CHECK_PROMOTION_RESET = "CHECK_PROMOTION_RESET"
export const CHECK_PROMOTION_ACTION = "CHECK_PROMOTION_ACTION"
export const CHECK_PROMOTION_SUCCESS = "CHECK_PROMOTION_SUCCESS"
export const CHECK_PROMOTION_FAIL = "CHECK_PROMOTION_FAIL"

export const PROMOTION_GET_HISTORY_CODE_ACTION = "PROMOTION_GET_HISTORY_CODE_ACTION"
export const PROMOTION_GET_HISTORY_CODE_SUCCESS = "PROMOTION_GET_HISTORY_CODE_SUCCESS"
export const PROMOTION_GET_HISTORY_CODE_FAIL = "PROMOTION_GET_HISTORY_CODE_FAIL"
export const PROMOTION_GET_HISTORY_CODE_RESET = "PROMOTION_GET_HISTORY_CODE_RESET"

export const PROMOTION_BULK_UPDATE_STATUS_ACTION = "PROMOTION_BULK_UPDATE_STATUS_ACTION"
export const PROMOTION_BULK_UPDATE_STATUS_FAIL = "PROMOTION_BULK_UPDATE_STATUS_FAIL"

// Bundles
export const BUNDLES_LIST_ACTION = "BUNDLES_LIST_ACTION";
export const BUNDLES_LIST_SUCCESS = "BUNDLES_LIST_SUCCESS";
export const BUNDLES_LIST_FAIL = "BUNDLES_LIST_FAIL";

export const BUNDLES_DETAIL_ACTION = "BUNDLES_DETAIL_ACTION";
export const BUNDLES_DETAIL_SUCCESS = "BUNDLES_DETAIL_SUCCESS";
export const BUNDLES_DETAIL_FAIL = "BUNDLES_DETAIL_FAIL";

export const BUNDLES_CREATE_ACTION = "BUNDLES_CREATE_ACTION";
export const BUNDLES_CREATE_SUCCESS = "BUNDLES_CREATE_SUCCESS";
export const BUNDLES_CREATE_FAIL = "BUNDLES_CREATE_FAIL";

export const BUNDLES_UPDATE_ACTION = "BUNDLES_UPDATE_ACTION";
export const BUNDLES_UPDATE_SUCCESS = "BUNDLES_UPDATE_SUCCESS";
export const BUNDLES_UPDATE_FAIL = "BUNDLES_UPDATE_FAIL";

export const BUNDLES_DEACTIVATED_CODE_ACTION = "BUNDLES_DEACTIVATED_CODE_ACTION";
export const BUNDLES_DEACTIVATED_CODE_SUCCESS = "BUNDLES_DEACTIVATED_CODE_SUCCESS";
export const BUNDLES_DEACTIVATED_CODE_FAIL = "BUNDLES_DEACTIVATED_CODE_FAIL";

export const BUNDLES_PARSE_EXCEL_ACTION = "BUNDLES_PARSE_EXCEL_ACTION";
export const BUNDLES_PARSE_EXCEL_SUCCESS = "BUNDLES_PARSE_EXCEL_SUCCESS";
export const BUNDLES_PARSE_EXCEL_FAIL = "BUNDLES_PARSE_EXCEL_FAIL";
export const BUNDLES_PARSE_EXCEL_CLEAR_ERROR = "BUNDLES_PARSE_EXCEL_CLEAR_ERROR";

// AutoFill
export const AUTOFILL_LIST_ACTION = "AUTOFILL_LIST_ACTION";
export const AUTOFILL_LIST_SUCCESS = "AUTOFILL_LIST_SUCCESS";
export const AUTOFILL_LIST_FAIL = "AUTOFILL_LIST_FAIL";

export const AUTOFILL_CREATE_ACTION = "AUTOFILL_CREATE_ACTION";
export const AUTOFILL_CREATE_SUCCESS = "AUTOFILL_CREATE_SUCCESS";
export const AUTOFILL_CREATE_FAIL = "AUTOFILL_CREATE_FAIL";

export const AUTOFILL_DETAIL_ACTION = "AUTOFILL_DETAIL_ACTION";
export const AUTOFILL_DETAIL_SUCCESS = "AUTOFILL_DETAIL_SUCCESS";
export const AUTOFILL_DETAIL_FAIL = "AUTOFILL_DETAIL_FAIL";

export const AUTOFILL_UPDATE_ACTION = "AUTOFILL_UPDATE_ACTION";
export const AUTOFILL_UPDATE_SUCCESS = "AUTOFILL_UPDATE_SUCCESS";
export const AUTOFILL_UPDATE_FAIL = "AUTOFILL_UPDATE_FAIL";

export const IMPORT_FILE_ACTION = "IMPORT_FILE_ACTION";
export const IMPORT_FILE_SUCCESS = "IMPORT_FILE_SUCCESS";
export const IMPORT_FILE_FAIL = "IMPORT_FILE_FAIL";

export const UPDATE_STATUS_GROUP_ACTION = "UPDATE_STATUS_GROUP_ACTION";
export const UPDATE_STATUS_GROUP_SUCCESS = "UPDATE_STATUS_GROUP_SUCCESS";
export const UPDATE_STATUS_GROUP_FAIL = "UPDATE_STATUS_GROUP_FAIL";

export const GET_FILE_STATUS_SAMPLE_ACTION = "GET_FILE_STATUS_SAMPLE_ACTION";
export const GET_FILE_STATUS_SAMPLE_SUCCESS = "GET_FILE_STATUS_SAMPLE_SUCCESS";
export const GET_FILE_STATUS_SAMPLE_FAIL = "GET_FILE_STATUS_SAMPLE_FAIL";
export const CLEAR_STATUS_GROUP = "CLEAR_STATUS_GROUP";

